import "./RequestTax.css";
import { useState, useEffect } from "react";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import usePersistedState from "../../../hooks/usePersistedState";
import {
  getUserApprover,
  getUserDelete,
  getUserEdit,
  getPutEdit,
} from "../../../redux/actions/fluxoNSimilar";
import { SkeletonWrapper } from "../../../componentes/SkeletonWrapper/sleketonWrapper";
import { GridColDef } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";
import HeadingAprovador from "../../fluxo-engenheiro/heading/headingAprovador";
import PartNumberCell from "../../fluxo-engenheiro/Requests/columns/partNumberCell";
import formatDateGrid from "../../../utils/formatDateGrid";
import GenericGrid from "../../fluxo-engenheiro/grid/grid";
import { useRoles } from "../../../hooks/roles";
import Edit from "../../../assets/img/edit.png";
import Delete from "../../../assets/img/excluir.png";
import SucessIcon from "../../../assets/svgs/sucess.svg";
import ModalAprover from "../modalAprover/modalAprover";
import functionDate from "../../../utils/formatarData";
import Textnotifications from "../../../utils/notifications";
import { EditModal } from "../../EditUserComponent/EditModal";
import { EditFormData } from "../smallModalEdit/smallModalEdit";
import Notification from "../Notification/notification";
import { usePersistedPagination } from "../../../hooks/usePersistedPagination";

export const AprovadorTax = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const { page, setPage } = usePersistedPagination("pagination_aprovador_tax");
  const [totalPages, setTotalPages] = useState<number | undefined>(undefined);
  const [modalDelete, setModalDelete] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState<string | null>(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [notification, setNotification] = useState(false);
  const [backgroudError, setBackgroudError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState<"create" | "edit">("create");
  const [selectedUser, setSelectedUser] = useState<EditFormData | null>(null);
  const [loadingEdit] = useState(false);
  const [labelNotification, SetLabelNotification] = useState("");

  const [email, setEmail] = usePersistedState("email", "");
  const { isTax } = useRoles();

  const { sessionUsers } = useSelector(
    (state: RootState) => state.sessionClassifications
  );

  const handleCreate = () => {
    setMode("create");
    setSelectedUser(null);
    setModalOpen(true);
  };

  const handleEdit = async (email: string) => {
    setMode("edit");

    const response = await dispatch(getUserEdit({ email })).unwrap();
    setSelectedUser({
      type: "tax",
      email: response.message.email,
      crea: response.message.crea,
    });

    setModalOpen(true);
  };

  const handleSuccess = (message: string) => {
    SetLabelNotification(message);
    setBackgroudError("#B8EFC9");
    setNotification(true);
    setTimeout(() => {
      setNotification(false);
    }, 5000);
  };

  const handleConfirm = async (data: EditFormData) => {
  try {
    if (data.type === "tax") {
      const payload = {
        email: data.email,
        crea: data.crea,
      };

      await dispatch(getPutEdit(payload)).unwrap();

      handleSuccess(
        mode === "edit"
          ? "Aprovador editado com sucesso."
          : "Aprovador cadastrado com sucesso."
      );

      await dispatch(getUserApprover({ page }));
      setModalOpen(false);
    }
  } catch (error) {
    console.error("Erro ao confirmar ação:", error);
  }
};

  const handleDelete = async () => {
    if (!selectedEmail) return;

    try {
      await dispatch(getUserDelete({ email: selectedEmail })).unwrap();
      await dispatch(getUserApprover({ page })).unwrap();

      handleSuccess("Aprovador deletado com sucesso.");
    } catch (error: any) {
      if (error?.message?.includes("404")) {
        setRows([]);
      }
    }
    setModalDelete(false);
  };

  const handleDisableButton = (isDisabled: boolean) => {
    setIsButtonDisabled(isDisabled);
  };

  const columns: GridColDef[] = [
    {
      field: "classificationId",
      headerClassName: "header-table",
      renderHeader: () => (
        <b className="partNumberColluns"> classificationId </b>
      ),
      renderCell: (params) => (
        <p className="partNumberColluns">{params.value}</p>
      ),
      flex: 1,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "email",
      headerClassName: "header-table",
      renderHeader: () => <b className="partNumberColluns"> E-mail </b>,
      renderCell: (params) => <PartNumberCell value={params.value as string} />,
      flex: 1.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "division",
      headerClassName: "header-table",
      renderHeader: () => <b className="descriptionColluns">Divisão</b>,
      renderCell: (params) => (params.value ? params.value : "N/A"),
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "crea",
      headerClassName: "header-table",
      renderHeader: () => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <b className="title-table"> Número do CREA</b>
        </div>
      ),
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => <div>{params.value}</div>,
    },
    {
      field: "updatedAt",
      headerClassName: "header-table",
      renderHeader: () => <b className="flagColluns">Criação Cadastro</b>,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <span className="centerTextBlack">
          {params.value ? formatDateGrid(params.value) : "N/A"}
        </span>
      ),
    },
    {
      field: "ações",
      headerClassName: "header-table",
      renderHeader: () => <b className="title-table">Ações</b>,
      flex: 0.7,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            gap: "20px",
            cursor: "pointer",
            alignItems: "center",
          }}
        >
          <Tooltip title="Editar">
            <button
              type="button"
              onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(params.row.email);
              }}
              aria-label="Editar"
              className="action-btns"
            >
              <img
                src={Edit}
                alt="Editar"                
                style={{ width: 20, height: 14 }}
              />
            </button>
          </Tooltip>
          <Tooltip title="Excluir">
            <button
              type="button"
              onClick={(e) => {
                setModalDelete(true);
                setSelectedEmail(params.row.email);
                e.stopPropagation();
              }}
              aria-label="Editar"
              className="action-btns"
            >
              <img
                src={Delete}
                alt="Excluir"
                style={{ width: 16, height: 20 }}
              />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    dispatch(getUserApprover({ page }));
  }, [page]);

  useEffect(() => {
    if (!isTax) return;

    if (sessionUsers) {
      setRows(sessionUsers.content);
      setTotalPages(sessionUsers.page.totalPages);
    }
  }, [isTax, sessionUsers]);

  const handleFilter = async () => {
    setLoading(true);
    await dispatch(
      getUserApprover({
        email: email.toString(),
      })
    ).finally(() => setLoading(false));
  };

  return (
    <div style={{ height: "100%" }}>
      <SkeletonWrapper loading={loading} />

      {!loading && (
        <>
          <div className="containerHomePage">
            <HeadingAprovador
              titlePage="Aprovador Engenheiro"
              titleButton="Cadastro Aprovador"
              filtros="sim"
              blockText="sim"
              emitentePartNumber={email}
              setEmitentePartDesc={setEmail}
              handleFilter={handleFilter}
              onOpen={handleCreate}
            />
          </div>

          <div className="containerRequest">
            <GenericGrid
              titleGrid="Engenheiros aprovadores cadastrados"
              rows={rows}
              totalPages={totalPages}
              page={page}
              columns={columns}
              setCurrentPage={setPage}
              setLoading={setLoading}
              setPage={setPage}
            />
          </div>
        </>
      )}

      {modalDelete && (
        <ModalAprover
          titleModal="Excluir Engenheiro Aprovador"
          titleDescription={
            <div
              style={{
                marginBottom: 20,
                marginTop: 15,
              }}
              className="titleAprover"
              dangerouslySetInnerHTML={{
                __html: functionDate.formatBodyText(
                  Textnotifications.getDeleteGeneric(
                    "Você deseja excluir esse Engenheiro Aprovador?",
                  ),
                ),
              }}
            />
          }
          bodyModal=""
          buttonOne="Confirmar"
          onConfirm={handleDelete}
          buttonTwo="Cancelar"
          onClose={() => setModalDelete(false)}
          isSubmitting={false}
        />
      )}

      {modalOpen && (
        <EditModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onConfirm={handleConfirm}
          mode={mode}
          initialData={selectedUser ?? undefined}
          isSubmitting={loadingEdit}
          isButtonDisabled={isButtonDisabled}
          onDisableButton={handleDisableButton}
          isAssociated={false}
        />
      )}

      {notification && (
        <Notification
          label={labelNotification}
          backgroundError={backgroudError}
          setNotification={setNotification}
          img={SucessIcon}
        />
      )}
    </div>
  );
};

export default AprovadorTax;
